var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConfluence(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7404 51.2099C17.244 52.0195 16.6865 52.9589 16.2129 53.7074C16.0092 54.0517 15.9487 54.4622 16.0443 54.8506C16.14 55.2391 16.3843 55.5745 16.7246 55.7848L26.6534 61.8948C26.826 62.0013 27.018 62.0724 27.2183 62.104C27.4186 62.1355 27.6231 62.1269 27.8201 62.0785C28.017 62.0302 28.2023 61.9431 28.3652 61.8224C28.5282 61.7017 28.6654 61.5497 28.769 61.3754C29.1662 60.711 29.6779 59.8479 30.2354 58.9238C34.1687 52.4319 38.125 53.2262 45.2584 56.6325L55.1032 61.3143C55.2878 61.4022 55.4881 61.4521 55.6922 61.4611C55.8964 61.4701 56.1004 61.4381 56.2919 61.3669C56.4835 61.2956 56.6589 61.1867 56.8076 61.0465C56.9563 60.9063 57.0753 60.7376 57.1577 60.5506L61.8853 49.858C62.0459 49.491 62.0558 49.0755 61.9129 48.7012C61.7701 48.327 61.4859 48.0238 61.1216 47.857C59.0442 46.8794 54.9123 44.9318 51.1928 43.137C37.8118 36.6375 26.4396 37.0576 17.7404 51.2099Z",
    fill: "url(#paint0_linear_47_15447)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2597 26.9455C62.7562 26.1359 63.3137 25.1965 63.7872 24.448C63.991 24.1037 64.0515 23.6932 63.9558 23.3047C63.8601 22.9163 63.6159 22.5809 63.2755 22.3706L53.3467 16.2606C53.1729 16.1435 52.9768 16.0634 52.7708 16.0254C52.5647 15.9873 52.353 15.9921 52.1488 16.0394C51.9446 16.0867 51.7524 16.1755 51.584 16.3002C51.4156 16.425 51.2747 16.5831 51.17 16.7646C50.7729 17.4291 50.2612 18.2922 49.7036 19.2163C45.7703 25.7082 41.8141 24.9139 34.6806 21.5076L24.8664 16.8487C24.6818 16.7608 24.4815 16.7109 24.2774 16.7019C24.0732 16.6929 23.8692 16.7249 23.6777 16.7961C23.4861 16.8673 23.3107 16.9763 23.162 17.1165C23.0133 17.2567 22.8943 17.4254 22.8119 17.6124L18.0843 28.3049C17.9237 28.672 17.9138 29.0875 18.0567 29.4617C18.1995 29.836 18.4837 30.1392 18.848 30.306C20.9254 31.2836 25.0573 33.2311 28.7768 35.026C42.1883 41.5179 53.5606 41.0825 62.2597 26.9455Z",
    fill: "url(#paint1_linear_47_15447)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_47_15447",
    x1: 61.618,
    y1: 65.0491,
    x2: 31.5796,
    y2: 47.7883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_47_15447",
    x1: 18.3821,
    y1: 13.0986,
    x2: 48.4282,
    y2: 30.3671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfluence);
export default __webpack_public_path__ + "static/media/confluence.f5df53b726f59e43a40de5048c9e75dc.svg";
export { ForwardRef as ReactComponent };